import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";
import { Link } from "react-router-dom";

const ViewVolet = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [voletData, setVoletData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [loading, setLoading] = useState(true);
    const [deletingId, setDeletingId] = useState(null);

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        fetchVoletData();
        fetchClients();
    }, []);

    useEffect(() => {
        if (selectedClient && voletData.length > 0) {
            const filtered = voletData.filter(item => {
                const itemClientId = Number(item.client_id);
                const selectedClientId = Number(selectedClient);
                return itemClientId === selectedClientId;
            });
            setFilteredData(filtered);
            console.log("Filtered data:", filtered);
        } else {
            setFilteredData([]);
        }
    }, [selectedClient, voletData]);

    const fetchVoletData = async () => {
        try {
            const response = await fetch("https://api.mitradingjp.com/fetchvolet.php");
            const data = await response.json();
            console.log("Fetched volet data:", data);

            const formattedData = data.map(item => ({
                ...item,
                client_id: Number(item.client_id),
                received_amount: parseFloat(item.received_amount) || 0,
                allocated_amount: parseFloat(item.allocated_amount) || 0,
                refund_amount: isNaN(parseFloat(item.refund_amount)) ? 0 : parseFloat(item.refund_amount),
                conversion_rate: parseFloat(item.conversion_rate) || 1
            }));
            setVoletData(formattedData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching volet data:", error);
            setLoading(false);
        }
    };

    const fetchClients = async () => {
        try {
            const response = await fetch("https://api.mitradingjp.com/fetchclients.php");
            const data = await response.json();
            console.log("Fetched clients:", data);
            setClients(data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const deleteVolet = async (id) => {
        if (!window.confirm("Are you sure you want to delete this record?")) return;

        console.log("Attempting to delete volet record with ID:", id);
        setDeletingId(id);

        try {
            const response = await fetch("https://api.mitradingjp.com/deletevolet.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ id }),
            });

            const responseData = await response.json();
            console.log("Delete response:", responseData, "Status:", response.status);

            if (!response.ok) {
                throw new Error(responseData.message || "Failed to delete record");
            }

            alert("Volet record deleted successfully!");
            await fetchVoletData();
        } catch (error) {
            console.error("Error deleting volet record:", error);
            alert(`Error deleting record: ${error.message}`);
        } finally {
            setDeletingId(null);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const formatCurrency = (amount) => {
        return `$${amount.toFixed(2)}`;
    };

    const formatPaymentMethod = (method) => {
        if (!method) return 'N/A';
        const methods = {
            'bank_transfer': 'Bank Transfer',
            'credit_card': 'Credit Card',
            'paypal': 'PayPal',
            'cash': 'Cash'
        };
        return methods[method] || method;
    };

    const formatConversionRate = (rate, currency) => {
        return `${rate.toFixed(4)} (${currency})`;
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3>View Volet</h3>
                    </div>

                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="clientFilter" className="form-label">Filter by Client</label>
                                    <select
                                        id="clientFilter"
                                        className="form-select"
                                        value={selectedClient}
                                        onChange={(e) => setSelectedClient(e.target.value)}
                                    >
                                        <option value="">Select a client</option>
                                        {clients.map(client => (
                                            <option key={client.id} value={client.id}>
                                                {client.name} ({client.username})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>ID</th>
                                        <th>Date</th>
                                        <th>Customer Name</th>
                                        <th>Payment Method</th>
                                        <th>Debit Amount</th>
                                        <th>Conversion Rate</th>
                                        <th>Refund Amount</th>
                                        <th>Allocation Amount</th>
                                        <th>Remaining Balance</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        (() => {
                                            let remainingBalance = 0;
                                            return filteredData.map((item, index) => {
                                                if (index === 0) {
                                                    remainingBalance = item.received_amount - item.allocated_amount - item.refund_amount;
                                                } else {
                                                    remainingBalance = remainingBalance + item.received_amount - item.allocated_amount - item.refund_amount;
                                                }

                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.id}</td>
                                                        <td>{formatDate(item.date)}</td>
                                                        <td>{item.client_name}</td>
                                                        <td>{formatPaymentMethod(item.payment_method)}</td>
                                                        <td>{formatCurrency(item.received_amount)}</td>
                                                        <td>{formatCurrency(item.conversion_rate)}</td>
                                                        <td>{formatCurrency(item.refund_amount)}</td>
                                                        <td>{formatCurrency(item.allocated_amount)}</td>
                                                        <td className={remainingBalance < 0 ? 'text-danger' : ''}>
                                                            {formatCurrency(remainingBalance)}
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => deleteVolet(item.id)}
                                                                disabled={deletingId === item.id}
                                                            >
                                                                {deletingId === item.id ? "Deleting..." : "Delete"}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            });
                                        })()
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                {selectedClient ? "No payment records found for selected client" : "Please select a client to view payments"}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewVolet;